import { Button, Typography } from "@mui/material";
import { type FC } from "react";
import { Link } from "react-router";

import { tradeLabelByMarketStatus } from "~/constants/tradeLabelByMarketStatus";
import { usePlatformTradeLink } from "~/feature/event/hooks/usePlatformTradeLink";
import { PlatformClickPlacement } from "~/scripts/platformClick";
import { type IAggregatedEvent, type IMarket } from "~/types/event";

interface IStatusCellProps {
  market: IMarket;
  event: IAggregatedEvent;
}

export const TradeButton: FC<IStatusCellProps> = ({ market, event }) => {
  const { href, handleClick } = usePlatformTradeLink(
    market,
    event,
    PlatformClickPlacement.EventDetail
  );

  return (
    <Button
      component={Link}
      to={href}
      target="_blank"
      rel="noopener noreferrer"
      size="small"
      variant="outlined"
      fullWidth
      onClick={handleClick}
      sx={{ height: 28 }}
    >
      <Typography variant="caption" sx={{
        textTransform: "none"
      }}>
        {tradeLabelByMarketStatus[market.unifiedStatus]}
      </Typography>
    </Button>
  );
};
